import User from './User.js'
import {FormattedRealDate} from '../../FormattedDate.js'
import Join from '../../Join.js'
import {formatTime} from '../../../date.js'

export default function BatchCreateDocumentComment({
  comment: {date, user, docs, printer_name},
}) {
  const parts = []
  if (docs.includes('label')) {
    parts.push('shipping label')
  }
  if (docs.includes('packing')) {
    parts.push('packing list')
  }
  if (docs.includes('pick')) {
    parts.push('pick list')
  }

  return (
    <dl className="list--order-data list--timeline-point">
      <dt className="list__item--order-data list__title--timeline-point">
        <FormattedRealDate value={date} format={formatTime} />
      </dt>
      <dd className="list__item--order-data list__item--timeline-point">
        Task started to create a <Join array={parts} /> document.
      </dd>
      {printer_name && (
        <dd className="list__item--order-data list__item--timeline-point">
          The document will then be InstaPrinted from this printer:{' '}
          {printer_name}
        </dd>
      )}
      <dd className="list__item--order-data list__item--timeline-point">
        {user && <User email={user} />}
      </dd>
    </dl>
  )
}
